import React from "react"

class FixPayment extends React.Component{

  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div>
        {/* <PaymentLog
          onSuccess={this.touchSystemNotification}

          amount={this.props.amount}
          card={this.props.card}
          customer={this.props.customer}
          date_format={this.props.date_format}
          default_payment_gateway={this.props.default_payment_gateway}
          failed_at={this.props.failed_at}
          failed_text={this.props.failed_text}
          id={this.props.id}
          log_type={this.props.log_type}
          payment_gateways={this.props.payment_gateways}
          processed_at={this.props.processed_at}
          refunded_at={this.props.refunded_at}
          scheduled_at={this.props.scheduled_at}
          time_format={this.props.time_format}
        /> */}
      </div>
    );
  }

  touchSystemNotification( msg ) {
    var self = this;

    if (msg && top.successGrowl) {
      top.successGrowl(msg);
    }

    if (top.touchSystemNotification) {
      top.touchSystemNotification(this.props.system_notification.id);
    }
  }

};

export default FixPayment